document.addEventListener('DOMContentLoaded', () => {
  const description = document.querySelector('[data-dgy-hotspots]');
  if (!description) return;

  const svg = description.querySelector('svg');
  const spots = [...svg.querySelectorAll('g[role="button"]')];

  if (!svg || spots.length < 3) return;
const openingSessionKey = 'dgy-opening-played';
const openingAlreadyPlayed =
  sessionStorage.getItem(openingSessionKey) === '1';

if (!openingAlreadyPlayed) {
  sessionStorage.setItem(openingSessionKey, '1');
}

  const products = [
  {
    title: '【ネクタイBOXセット】ドラえもん｜ストライプ×笑顔・後ろ向き',
    url: 'https://deargeyone.com/products/doraemon-tie-box-set-stripe',
    image: 'https://cdn.shopify.com/s/files/1/0672/0179/4298/files/112016203-all.webp?v=1791722333'
  },
  {
    title: '【ネクタイBOXセット】ドラえもん｜ドット×後ろ向き・おしり',
    url: 'https://deargeyone.com/products/doraemon-tie-box-set-dot',
    image: 'https://cdn.shopify.com/s/files/1/0672/0179/4298/files/112016202-all.webp?v=1791767170'
  },
  {
    title: '【ネクタイBOXセット】ドラえもん｜チェック×鈴・タケコプター',
    url: 'https://deargeyone.com/products/doraemon-tie-box-set-check',
    image: 'https://cdn.shopify.com/s/files/1/0672/0179/4298/files/112016201-all.webp?v=1791769287'
  }
];

  const viewBox = (svg.getAttribute('viewBox') || '0 0 1668 3115')
    .trim()
    .split(/\s+/)
    .map(Number);

  const viewBoxWidth = viewBox[2];
  const viewBoxHeight = viewBox[3];

  /*
   * レイヤーの基準をページ全体ではなく、
   * data-dgy-hotspots 内のSVG表示領域に固定する
   */
  const frame = description;

  frame.style.setProperty('position', 'relative', 'important');
  frame.style.setProperty('display', 'block', 'important');
  frame.style.setProperty('z-index', '0', 'important');
  frame.style.setProperty('isolation', 'isolate', 'important');

  const layer = document.createElement('div');
  layer.className = 'dgy-hotspot-layer';

  layer.style.setProperty('position', 'absolute', 'important');
  layer.style.setProperty('z-index', '2', 'important');
  layer.style.setProperty('pointer-events', 'none', 'important');
  layer.style.setProperty('margin', '0', 'important');
  layer.style.setProperty('padding', '0', 'important');

  frame.appendChild(layer);

  /*
   * SVGの実際の表示位置・サイズにレイヤーを完全一致させる
   */
  const syncLayerToSvg = () => {
    const frameRect = frame.getBoundingClientRect();
    const svgRect = svg.getBoundingClientRect();

    layer.style.setProperty(
      'left',
      `${svgRect.left - frameRect.left}px`,
      'important'
    );

    layer.style.setProperty(
      'top',
      `${svgRect.top - frameRect.top}px`,
      'important'
    );

    layer.style.setProperty(
      'width',
      `${svgRect.width}px`,
      'important'
    );

    layer.style.setProperty(
      'height',
      `${svgRect.height}px`,
      'important'
    );
  };

  syncLayerToSvg();

  window.addEventListener('resize', syncLayerToSvg, {
    passive: true
  });

  if ('ResizeObserver' in window) {
    const resizeObserver = new ResizeObserver(syncLayerToSvg);
    resizeObserver.observe(svg);
  }

  window.requestAnimationFrame(syncLayerToSvg);

 const motionGroup =
  svg.querySelector('g[pointer-events="none"]') ||
  [...svg.children].find((element) =>
    element.tagName.toLowerCase() === 'g' &&
    element.children.length === 6 &&
    element.querySelector('image')
  );

const motionItems = motionGroup
  ? [...motionGroup.children]
  : [];

const showFinalAnimationState = () => {
  if (motionItems.length < 6) return;

  const [
    rightCloud,
    leftCloud,
    banner,
    openingDoraemon,
    flyingDoraemon,
    hoveringDoraemon
  ] = motionItems;

  motionItems.forEach((item) => {
    item.querySelectorAll('animate, set').forEach((animation) => {
      animation.remove();
    });
  });

  rightCloud.setAttribute('y', '575');
  rightCloud.setAttribute('opacity', '1');

  leftCloud.setAttribute('y', '940');
  leftCloud.setAttribute('opacity', '1');

  banner.setAttribute('opacity', '1');

  openingDoraemon.setAttribute('opacity', '0');
  flyingDoraemon.setAttribute('opacity', '0');

  hoveringDoraemon.setAttribute('y', '620');
  hoveringDoraemon.setAttribute('opacity', '1');
};

if (openingAlreadyPlayed) {
  showFinalAnimationState();
  layer.classList.add('is-visible');
} else {
  window.setTimeout(() => {
    layer.classList.add('is-visible');
    }, 4500);
}

  spots.slice(0, 3).forEach((spot, index) => {
    const match = spot.getAttribute('transform')?.match(
      /translate\(\s*([-\d.]+)[ ,]+([-\d.]+)\s*\)/
    );

    if (!match) return;

    spot.style.setProperty('visibility', 'hidden', 'important');

    const x = Number(match[1]);
    const y = Number(match[2]);

    const hotspot = document.createElement('div');
    hotspot.className = 'dgy-hotspot';

    hotspot.style.setProperty(
      'left',
      `${(x / viewBoxWidth) * 100}%`,
      'important'
    );

    hotspot.style.setProperty(
      'top',
      `${(y / viewBoxHeight) * 100}%`,
      'important'
    );

    hotspot.style.setProperty('position', 'absolute', 'important');

hotspot.style.setProperty(
  'transform',
  'translate(-50%, -50%)',
  'important'
);

hotspot.style.setProperty('z-index', '3');

hotspot.style.setProperty('pointer-events', 'auto', 'important');


    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'dgy-hotspot-button';
    button.setAttribute(
      'aria-label',
      `${products[index].title}を表示`
    );
    button.setAttribute('aria-expanded', 'false');
    button.textContent = '+';

    const card = document.createElement('a');
    card.className = 'dgy-product-card';
    card.href = products[index].url;
    card.innerHTML = `
      <img src="${products[index].image}" alt="${products[index].title}">
      <strong>${products[index].title}</strong>
    `;

    button.addEventListener('click', (event) => {
      event.stopPropagation();

      document
        .querySelectorAll('.dgy-hotspot.is-open')
        .forEach((item) => {
          if (item !== hotspot) {
            item.classList.remove('is-open');
          }
         
        });

 const isOpen = hotspot.classList.toggle('is-open');

layer.querySelectorAll('.dgy-hotspot').forEach((item) => {
  item.style.setProperty('z-index', '3', 'important');
});

if (isOpen) {
  hotspot.style.setProperty('z-index', '30', 'important');
}

layer.classList.toggle('has-open-card', isOpen);

    button.setAttribute(
    'aria-expanded',
    isOpen ? 'true' : 'false'
    );
    });
/* 商品カードを画面の左右端から12px内側へ補正 */
const fitCardInViewport = () => {
  card.style.translate = '0px 0px';

  const rect = card.getBoundingClientRect();
  const viewportWidth = document.documentElement.clientWidth;
  const margin = 12;
  let offsetX = 0;

  if (rect.left < margin) {
    offsetX = margin - rect.left;
  } else if (rect.right > viewportWidth - margin) {
    offsetX = viewportWidth - margin - rect.right;
  }

  card.style.translate = `${offsetX}px 0px`;
};

/* PCでホバーしたとき */
hotspot.addEventListener('mouseenter', () => {
  window.requestAnimationFrame(fitCardInViewport);
});

/* スマホでタップしたとき */
button.addEventListener('click', () => {
  if (hotspot.classList.contains('is-open')) {
    window.requestAnimationFrame(fitCardInViewport);
  }
});

/* 表示中に画面幅が変わったとき */
window.addEventListener('resize', () => {
  if (
    hotspot.classList.contains('is-open') ||
    hotspot.matches(':hover')
  ) {
    window.requestAnimationFrame(fitCardInViewport);
  }
});

    hotspot.append(button, card);
    layer.appendChild(hotspot);
  });

 document.addEventListener('click', (event) => {
  if (!event.target.closest('.dgy-hotspot')) {
    document
      .querySelectorAll('.dgy-hotspot.is-open')
      .forEach((item) => {
        item.classList.remove('is-open');
      });

    layer.classList.remove('has-open-card');
  }
  });
});
